/**
 * Runtime API base URL resolution.
 *
 * The same frontend bundle is deployed to:
 *   1. neurohealhaven.com  — same-origin backend (Emergent)
 *   2. venusglowhaven.com  — frontend on Netlify (static), backend on
 *                            neurohealhaven.com → cross-origin
 *   3. Preview/dev         — REACT_APP_BACKEND_URL points at the dev backend
 *
 * `apiBase()` returns the correct base URL ("…/api" not included) for the
 * current host. All axios callers should consume this instead of reading
 * `process.env.REACT_APP_BACKEND_URL` directly.
 */
const NEUROHEAL_PROD = 'https://neurohealhaven.com';
const VENUS_HOSTS = new Set(['venusglowhaven.com', 'www.venusglowhaven.com']);

let cached = null;

export const apiBase = () => {
  if (cached) return cached;
  if (typeof window !== 'undefined') {
    if (VENUS_HOSTS.has(window.location.hostname)) {
      cached = NEUROHEAL_PROD;
      return cached;
    }
  }
  // Same-origin on production app host AND on preview/dev (where the env var
  // points at the dev backend).
  cached = process.env.REACT_APP_BACKEND_URL || '';
  return cached;
};

export default apiBase;
